export default __webpack_public_path__ + "static/media/ciee-logo.c7d13a9a.jpeg";